import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'

const SectionContainer = ({children, ...props}) => (
  <Flex
    p="md"
    direction="column"
    gap="md"
    bgColor="mld.neutral.0"
    borderRadius="lg"
    {...props}
  >
    {children}
  </Flex>
)

SectionContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SectionContainer
